export type Language = 'cs' | 'en';

export const translations = {
  cs: {
    nav: {
      home: 'Domov',
      about: 'O mně',
      services: 'Služby',
      pricing: 'Ceník',
      contact: 'Kontakt',
    },
    hero: {
      subtitle: 'CrossFit Trainer & Fitness Coach',
      cta: 'Rezervovat trénink',
      ctaOnline: 'Rezervovat online',
      ctaAbout: 'Více o mně',
    },
    about: {
      title: 'O mně',
      paragraph1: 'Od malička jsem byl ponořený do světa sportu, kde jsem si vyzkoušel vše od tenisu, fotbalu až po hokej. Právě lední hokej si mě získal na dlouhých osmnáct let. Můj poslední rok na ledě byl zlomový, stal jsem se trenérem hokejové mládeže.',
      paragraph2: 'V roce 2021 jsem překročil hranice své sportovní kariéry a objevil svět crossfitu. Propadl jsem mu od samého začátku, přestože první pokroky nebyly snadné. Crossfit mě naučil nejen o síle a vytrvalosti, ale i o pokoře a odhodlání.',
      paragraph3: 'Ve sportech mám stálou touhu se učit a jsem otevřen novým informacím, které mohou obohatit mé tréninkové metody. V Crossfit Destiny mě můžete najít pod vedením crossfitových, vzpěračských, začátečnických i kruhových tréninků.',
      keyPoint1Title: 'Absolvent kurzů',
      keyPoint1Desc: 'Osobní trenér fitness & vzpírání',
      keyPoint2Title: 'Pro všechny úrovně',
      keyPoint2Desc: 'Od začátečníků po výkonnostní sportovce',
      keyPoint3Title: 'Komplexní přístup',
      keyPoint3Desc: 'Trénink + výživové poradenství',
      paragraph4: 'Jako trenér se zaměřuji na široké spektrum jednotlivců, od běžných pracujících přes výkonnostní sportovce až po děti. Mým hlavním cílem je dlouhodobě adaptovat jejich pohybové schopnosti a dovednosti k požadovaným kritériím crossfitu.',
      paragraph5: 'Snažím se sdílet mou cestu crossfitem a učinit ji přístupnou pro všechny, kteří mají odvahu se přidat. Jsem k dispozici na sociálních sítích, takže pokud chcete se mnou spolupracovat, neváhejte mě kontaktovat!',
    },
    services: {
      title: 'Služby & Tréninky',
      crossfit: {
        title: 'CrossFit Tréninky',
        description: 'Komplexní funkční tréninky kombinující gymnastiku, vzpírání a kondiční cvičení.',
        features: ['Funkční pohyby', 'HIIT tréninky', 'Technika vzpírání'],
      },
      group: {
        title: 'Skupinové Lekce',
        description: 'Motivační skupinové tréninky pro všechny úrovně od začátečníků po pokročilé.',
        features: ['Začátečnické kurzy', 'Kruhové tréninky', 'Komunitní atmosféra'],
      },
      personal: {
        title: 'Osobní Tréninky',
        description: 'Individuální přístup s důrazem na vaše cíle a aktuální kondici.',
        features: ['1:1 tréninky', 'Program na míru', 'Pravidelné konzultace'],
      },
      onlineAthlete: {
        title: 'Online Individuální Program - Athlete',
        description: 'Pokročilý online tréninkový program pro výkonnostní sportovce s detailní analýzou a pravidelnými konzultacemi.',
        features: ['Pokročilý program', 'Detailní analýza', 'Pravidelné konzultace', 'Sledování pokroku'],
      },
      onlineBasic: {
        title: 'Online Individuální Program - Basic',
        description: 'Základní online tréninkový program s tréninkovými plány a emailovou podporou.',
        features: ['Základní program', 'Tréninkové plány', 'Emailová podpora', 'Sledování pokroku'],
      },
      nutrition: {
        title: 'Výživové Poradenství',
        description: 'Komplexní přístup k výživě podporující vaše tréninkové cíle.',
        features: ['Jídelní plány', 'Makro kalkulace', 'Sportovní výživa'],
      },
      galleryTitle: 'Trénink v akci',
    },
    pricing: {
      title: 'Ceník',
      individual: {
        title: 'Osobní trénink',
        description: 'Individuální tréninkové lekce na míru přizpůsobené vašim specifickým cílům a úrovni kondice.',
        pricingByPeopleTitle: 'Ceník podle počtu osob:',
        pricingByFrequencyTitle: 'Ceník podle frekvence:',
        pricingOptions: [
          { label: '1 osoba', price: '750,-', period: '/ lekce' },
          { label: '2 osoby', price: '800,-', period: '/ lekce' },
          { label: '3 osoby', price: '900,-', period: '/ lekce' },
          { label: '4+ osoby', price: '250,-', period: '/ osobu' },
        ],
        frequencyOptions: [
          { label: '2x týdně', price: '700,-' },
          { label: '3x týdně', price: '650,-' },
          { label: '4x týdně a víc', price: 'dle domluvy', period: '' },
        ],
        features: ['60 minut na lekci', 'Tréninkové plány na míru', 'Sledování pokroku'],
        disclaimer: '*Je nutné zaplatit vstupné do posilovny zvlášť, protože poplatek za trénink nezahrnuje vstupné do zařízení.*',
      },
      online: {
        title: 'Online Individuální Program',
        description: 'Individuální online tréninkové programy přizpůsobené vašim cílům a úrovni.',
        period: 'za 4 týdny',
        athlete: {
          title: 'Athlete',
          price: '3500,-',
          features: ['Pokročilý program', 'Detailní analýza', 'Pravidelné konzultace', 'Sledování pokroku'],
        },
        basic: {
          title: 'Basic',
          price: '2200,-',
          features: ['Základní program', 'Tréninkové plány', 'Emailová podpora', 'Sledování pokroku'],
        },
      },
    },
    contact: {
      title: 'Kontakt & Rezervace',
      heading: 'Pojďme spolupracovat!',
      paragraph1: 'Jsem k dispozici na sociálních sítích, takže pokud chcete se mnou spolupracovat, neváhejte mě kontaktovat, nebo se mě nebojte oslovit v gymu!',
      paragraph2: 'Budu se na vás těšit! 💪',
      followMe: 'Sledujte mě',
      professionalLinks: 'Profesionální odkazy',
      gymTitle: 'CrossFit Destiny',
      gymDescription: 'Trénuji v moderním fitness centru specializujícím se na crossfit a funkční tréninky.',
      visitGym: 'Navštívit web gymu',
      bookingTitle: 'Kontakt',
      bookingDescription: 'Připraven začít svou crossfit cestu? Rezervujte si osobní trénink nebo se připojte ke skupinové lekci.',
      emailButton: 'Email',
      whatsappButton: 'WhatsApp',
      phoneButton: 'Telefon',
      email: 'kontakt@martinsenk.cz',
      emailMessage: 'Ahoj Martine, chtěl bych se dohodnout na tréninku.',
      whatsappMessage: 'Ahoj Martine, chtěl bych se dohodnout na tréninku.',
      phoneNumber: '+420775648863',
      openInGoogleMaps: 'Otevřít v Google Maps',
    },
    footer: {
      copyright: '© 2025 Martin Šenk. Všechna práva vyhrazena.',
      madeBy: 'Web vytvořil',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      pricing: 'Pricing',
      contact: 'Contact',
    },
    hero: {
      subtitle: 'CrossFit Trainer & Fitness Coach',
      cta: 'Book a Training',
      ctaOnline: 'Book Online',
      ctaAbout: 'More About Me',
    },
    about: {
      title: 'About Me',
      paragraph1: 'From a young age, I was immersed in the world of sports, trying everything from tennis and football to hockey. Ice hockey captured me for eighteen long years. My last year on the ice was pivotal, as I became a youth hockey coach.',
      paragraph2: 'In 2021, I crossed the boundaries of my sports career and discovered the world of CrossFit. I fell in love with it from the very beginning, even though the first progress wasn\'t easy. CrossFit taught me not only about strength and endurance but also about humility and determination.',
      paragraph3: 'In sports, I have a constant desire to learn and I\'m open to new information that can enrich my training methods. At CrossFit Destiny, you can find me leading CrossFit, weightlifting, beginner, and circuit training sessions.',
      keyPoint1Title: 'Course Graduate',
      keyPoint1Desc: 'Personal fitness & weightlifting trainer',
      keyPoint2Title: 'For All Levels',
      keyPoint2Desc: 'From beginners to performance athletes',
      keyPoint3Title: 'Comprehensive Approach',
      keyPoint3Desc: 'Training + nutritional counseling',
      paragraph4: 'As a trainer, I focus on a wide spectrum of individuals, from regular workers to performance athletes and children. My main goal is to long-term adapt their movement abilities and skills to the required CrossFit criteria.',
      paragraph5: 'I try to share my CrossFit journey and make it accessible to everyone who has the courage to join. I\'m available on social media, so if you want to work with me, don\'t hesitate to contact me!',
    },
    services: {
      title: 'Services & Training',
      crossfit: {
        title: 'CrossFit Training',
        description: 'Comprehensive functional training combining gymnastics, weightlifting, and conditioning exercises.',
        features: ['Functional movements', 'HIIT training', 'Weightlifting technique'],
      },
      group: {
        title: 'Group Classes',
        description: 'Motivational group training for all levels from beginners to advanced.',
        features: ['Beginner courses', 'Circuit training', 'Community atmosphere'],
      },
      personal: {
        title: 'Personal Training',
        description: 'Individual approach with emphasis on your goals and current fitness level.',
        features: ['1:1 training', 'Custom program', 'Regular consultations'],
      },
      onlineAthlete: {
        title: 'Online Individual Programming - Athlete',
        description: 'Advanced online training program for performance athletes with detailed analysis and regular consultations.',
        features: ['Advanced program', 'Detailed analysis', 'Regular consultations', 'Progress tracking'],
      },
      onlineBasic: {
        title: 'Online Individual Programming - Basic',
        description: 'Basic online training program with training plans and email support.',
        features: ['Basic program', 'Training plans', 'Email support', 'Progress tracking'],
      },
      nutrition: {
        title: 'Nutrition Counseling',
        description: 'Comprehensive approach to nutrition supporting your training goals.',
        features: ['Meal plans', 'Macro calculations', 'Sports nutrition'],
      },
      galleryTitle: 'Training in Action',
    },
    pricing: {
      title: 'Pricing',
      individual: {
        title: 'Personal Training',
        description: 'Individual training sessions tailored to your specific goals and fitness level.',
        pricingByPeopleTitle: 'Pricing by number of people:',
        pricingByFrequencyTitle: 'Pricing by frequency:',
        pricingOptions: [
          { label: '1 person', price: '750 CZK', period: '/ session' },
          { label: '2 people', price: '800 CZK', period: '/ session' },
          { label: '3 people', price: '900 CZK', period: '/ session' },
          { label: '4+ people', price: '250 CZK', period: '/ person' },
        ],
        frequencyOptions: [
          { label: '2x per week', price: '700 CZK', period: '/ person' },
          { label: '3x per week', price: '650 CZK', period: '/ person' },
          { label: '4x per week and more', price: 'by agreement', period: '' },
        ],
        features: ['60 minutes per session', 'Custom training plans', 'Progress tracking'],
        disclaimer: '*Gym entry fee must be paid separately, as the training fee does not include facility access.*',
      },
      online: {
        title: 'Online Individual Programming',
        description: 'Individual online training programs tailored to your goals and level.',
        period: 'per 4 weeks',
        athlete: {
          title: 'Athlete',
          price: '3500 CZK',
          features: ['Advanced program', 'Detailed analysis', 'Regular consultations', 'Progress tracking'],
        },
        basic: {
          title: 'Basic',
          price: '2200 CZK',
          features: ['Basic program', 'Training plans', 'Email support', 'Progress tracking'],
        },
      },
    },
    contact: {
      title: 'Contact & Booking',
      heading: 'Let\'s Work Together!',
      paragraph1: 'I\'m available on social media, so if you want to work with me, don\'t hesitate to contact me, or feel free to approach me at the gym!',
      paragraph2: 'Looking forward to meeting you! 💪',
      followMe: 'Follow Me',
      professionalLinks: 'Professional Links',
      gymTitle: 'CrossFit Destiny',
      gymDescription: 'I train at a modern fitness center specializing in CrossFit and functional training.',
      visitGym: 'Visit gym website',
      bookingTitle: 'Contact',
      bookingDescription: 'Ready to start your CrossFit journey? Book a personal training session or join a group class.',
      emailButton: 'Email',
      whatsappButton: 'WhatsApp',
      phoneButton: 'Phone',
      email: 'kontakt@martinsenk.cz',
      emailMessage: 'Hi Martin, I would like to arrange a training session.',
      whatsappMessage: 'Hi Martin, I would like to arrange a training session.',
      phoneNumber: '+420775648863',
      openInGoogleMaps: 'Open in Google Maps',
    },
    footer: {
      copyright: '© 2025 Martin Šenk. All rights reserved.',
      madeBy: 'Web by',
    },
  },
};

